<template>
    <div class='overview-list-item'>
        <div class="columns">
            <div class="column">
                <ul>
                    <li><h4 class="is-size-5 subtitle">{{project.name}}</h4></li>
                    <br>

                    <li>Færdighed: {{$t(`skills.${project.skill.name}.name`)}}</li>
                    <br>
                </ul>
            </div>

            <div class="column">
                <article class="media" v-if="isStudent">
                    <figure class="media-left">
                        <avatar :size="64" :account="project.customer" />
                    </figure>

                    <div class="media-content">
                        <div class="content">
                            <p>
                                <strong>{{project.customer.name}}</strong>
                                <br>
                            </p>
                        </div>
                    </div>
                </article>

                <article class="media" v-else>
                    <figure class="media-left">
                        <avatar :size="64" :account="project.student" round />
                    </figure>

                    <div class="media-content">
                        <div class="content">
                            <p>
                                <router-link :to="{ name: 'students.profile', params: { slug: project.student.slug }}">
                                    <strong>{{project.student.name}}</strong>
                                </router-link>
                            </p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column">
                <p>Status:
                    <strong>
                        {{$t(`projects.status.${project.status}`)}}
                    </strong>
                </p>
                <br>
                <!--<a class="button is-primary is-small">Se detaljer</a>-->

                <router-link class="button is-small" :to="{ name: 'conversations.conversation', params: { id: project.conversation.id }}">
                    Gå til samtale
                </router-link>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/variables';

    .overview-list-item {
        padding-bottom: 15px;

        &:not(:last-child) {
            border-bottom: 2px solid $white-ter;
        }
    }

</style>

<script>
    import Avatar from '@/taskflex/users/components/Avatar';
    import { mapGetters } from 'vuex';
    import SkillTag from '@/taskflex/skills/components/SkillTag';

    export default {
        props: {
            project: {
                required: true,
            },
        },

        computed: {
            ...mapGetters('auth', [
                'isStudent',
            ]),
        },

        components: {
            Avatar,
            SkillTag,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/projects/components/OverviewListItem.vue